<template>
    <div class="animated fadeIn">
        <b-row>
          <b-col class="new-user-form">
            <h4 class="new-user-form__header col-form-label-lg">
              <slot name="form-header"></slot>
            </h4>
            <b-form-group class="new-user-form__group" label-size='lg' label-class='adduserlabel' label='Full Name' label-for='fullName' :horizontal='false'>
              <b-form-input :data-vv-name="`user-${id}.fullName`" v-validate="'required|max:255'" data-vv-as="Full Name" size="lg" id='fullName' v-model='user.fullName'></b-form-input>
              <span v-show="inputValidationErrors.has(`user-${id}.fullName`)" class="text-info">{{ inputValidationErrors.first(`user-${id}.fullName`) }}</span>
            </b-form-group>

            <b-form-group class="new-user-form__group" label-size='lg' label-class='adduserlabel' label='Email Address' label-for='emailAddress' :horizontal='false'>
              <b-form-input
                id='emailAddress'
                size="lg"
                v-validate="'required|email|max:255|uniqueUserEmail'"
                :data-vv-name="`user-${id}.emailAddress`"
                data-vv-as="Email Address"
                autocomplete="email"
                v-model='user.emailAddress'
              ></b-form-input>
              <span v-show="inputValidationErrors.has(`user-${id}.emailAddress`)" class="text-info">{{ inputValidationErrors.first(`user-${id}.emailAddress`) }}</span>
            </b-form-group>

            <b-form-group class="new-user-form__group" label-size='lg' label-class='adduserlabel' label='Active' label-for='active' :horizontal='false'>
              <b-form-select
               @change="handleSelect"
               :data-vv-name="`user-${id}.active`"
               v-validate="'required'"
               data-vv-as="Active"
               size="lg"
               :value="user.isRemoved ? 'Deactivate' : user.active"
               :options="getUserActiveOptions(isSuperAdminOptions)"
               id='active'>
              </b-form-select>
               <span v-show="inputValidationErrors.has(`user-${id}.active`)" class="text-info">{{ inputValidationErrors.first(`user-${id}.active`) }}</span>
            </b-form-group>

            <b-form-group class="new-user-form__group" label-size='lg' label-class='adduserlabel' label='Super Admin' label-for='isSuperAdmin' :horizontal='false'>
              <b-form-select
              :data-vv-name="`user-${id}.isSuperAdmin`"
              v-validate="'required'"
              data-vv-as="is Super Admin"
               size="lg" :options="isSuperAdminOptions" id='isSuperAdmin' v-model='user.isSuperAdmin'>
              </b-form-select>
               <span v-show="inputValidationErrors.has(`user-${id}.isSuperAdmin`)" class="text-info">{{ inputValidationErrors.first(`user-${id}.isSuperAdmin`) }}</span>
            </b-form-group>

            <b-form-group class="new-user-form__group" label-size='lg' label-class='adduserlabel' label='Password' label-for='password' :horizontal='false'>
              <b-form-input
                id='password'
                type="password"
                v-validate="`${passwordRequired ? 'required|min:8|max:255' : 'max:255|min:8'}`"
                :data-vv-name="`user-${id}.password`"
                data-vv-as="Password"
                autocomplete="new-password"
                size="lg"
                v-model='user.password'
              ></b-form-input>
              <span v-show="inputValidationErrors.has(`user-${id}.password`)" class="text-info">{{ inputValidationErrors.first(`user-${id}.password`) }}</span>
            </b-form-group>

            <div class="new-user-form__group new-user-form__wrapper">
              <b-form-group label-size='lg' label-class='adduserlabel' label='CSE-IT Trained?' label-for='cse-it-trained' :horizontal='false'>
                <label class="switch switch-lg switch-text switch-pill switch-primary-outline-alt mb-0 wide-toggle">
                  <input
                    id="positive_switch"
                    @change="toggleIsCseitTrained"
                    type="checkbox"
                    class="switch-input"
                    :checked="user.isCseitTrained"
                  >
                  <span class="switch-label" data-on="CSE-IT Trained" data-off="Not CSE-IT Trained"></span>
                  <span class="switch-handle"></span>
                </label>
              </b-form-group>

              <b-form-group label-size='lg' label-class='adduserlabel' label='Organization Manager?' label-for='isOrgManagerOff' :horizontal='false'>
                <label class="switch switch-lg switch-text switch-pill switch-primary-outline-alt mb-0 wide-toggle">
                  <input
                    id="positive_switch"
                    v-model="user.membership.isManager"
                    type="checkbox"
                    class="switch-input"
                  >
                  <span class="switch-label" data-on="Yes" data-off="No"></span>
                  <span class="switch-handle"></span>
                </label>
              </b-form-group>

              <b-form-group label-size='lg' label-class='adduserlabel' label='Care Coordinator?' label-for='isCareCoordinatorOff' :horizontal='false'>
                <label class="switch switch-lg switch-text switch-pill switch-primary-outline-alt mb-0 wide-toggle">
                  <input
                    id="positive_switch"
                    v-model="user.membership.isCareCoordinator"
                    type="checkbox"
                    class="switch-input"
                  >
                  <span class="switch-label" data-on="Yes" data-off="No"></span>
                  <span class="switch-handle"></span>
                </label>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  name: 'new-user-form',

  inject: ['$validator'],

  props: {
    id: {
      type: Number,
      default: 0
    },

    formUser: {
      type: Object,
      default () {
        return {}
      }
    },

    isSubmitLoading: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      user: cloneDeep(this.formUser)
    }
  },

  computed: {
    ...mapGetters({
      isSuperAdminOptions: 'getIsSuperAdminOptions'
    }),

    passwordRequired () {
      return this.user.id === 0
    }
  },

  watch: {
    isSubmitLoading (newValue) {
      if (newValue) {
        this.$emit('submit', this.user)
      }
    }
  },

  methods: {
    getUserActiveOptions (options) {
      return [
        ...options,
        { value: 'Deactivate', text: 'Deactivate' }
      ]
    },

    handleSelect (value) {
      if (value === 'Deactivate') {
        this.user.isRemoved = true
      } else {
        this.user.isRemoved = false
        this.user.active = value
      }
    },

    toggleIsCseitTrained (val) {
      this.user.isCseitTrained = !this.user.isCseitTrained
      // auto select active as Yes
      if (this.user.isCseitTrained) {
        this.user.active = true
        this.user.isRemoved = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.new-user-form {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  gap: 20px;

  &__header {
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
    flex-basis: 100%;
  }

  &__group {
    flex-basis: calc(50% - 20px);
    align-items: center;
  }

  &__wrapper {
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
}

.switch.switch-text.switch-lg.wide-toggle {
  width: 180px;

  .switch-input:checked ~ .switch-handle {
    left: 154px; // 180px - 24px (pill size) - 2px (offset)
  }

  .switch-label {
    &::after,
    &::before {
      width: 156px; // 180px - 24px (pill size)
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/t1/Admin/NewUserForm.vue